// extracted by mini-css-extract-plugin
export default {"container":"Completedproject_container__tT7LT","count":"Completedproject_count__Sq9TK","name":"Completedproject_name__hPg+3"};